interface HousingPackageFormFieldsProps {
  formData: Record<string, string>;
  onChange: (key: string, value: string) => void;
}

const HousingPackageFormFields = ({ formData, onChange }: HousingPackageFormFieldsProps) => {
  return (
    <>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="PackageFor">
          Package is for
        </label>
        <div className="col-sm-6">
          <select className="form-control" name="PackageFor" id="PackageFor" value={formData?.PackageFor ?? '.'} onChange={(e) => onChange('PackageFor', e.target.value)}>
            <option value="."> </option>
            <option value="Myself">Myself</option>
            <option value="ParentGuardian">Parent / Guardian</option>
            <option value="FamilyMember">Family Member</option>
            <option value="Chaperone">Chaperone</option>
            <option value="Teacher">Teacher</option>
            <option value="Student">Student</option>
          </select>
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="OccupantsFirstName">
          Occupant's First Name
        </label>
        <div className="col-sm-6">
          <input
            className="form-control"
            type="text"
            name="OccupantsFirstName"
            id="OccupantsFirstName"
            value={formData?.OccupantsFirstName ?? ''}
            onChange={(e) => onChange('OccupantsFirstName', e.target.value)}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="OccupantsLastName">
          Occupant's Last Name
        </label>
        <div className="col-sm-6">
          <input
            className="form-control"
            type="text"
            name="OccupantsLastName"
            id="OccupantsLastName"
            value={formData?.OccupantsLastName ?? ''}
            onChange={(e) => onChange('OccupantsLastName', e.target.value)}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="OccupantsAge">
          Occupant's Age
        </label>
        <div className="col-sm-6">
          <select className="form-control" name="OccupantsAge" id="OccupantsAge" value={formData?.OccupantsAge ?? '.'} onChange={(e) => onChange('OccupantsAge', e.target.value)}>
            <option value="."> </option>
            <option value="0-5">0 - 5 Years Old</option>
            <option value="6-10">6 - 10 Years Old</option>
            <option value="11-13">11 - 13 Years Old</option>
            <option value="14-17">14 - 17 Years Old</option>
            <option value="18+"> 18 and Older</option>
          </select>
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="OccupantsGender">
          Occupant's Gender
        </label>
        <div className="col-sm-6">
          <select
            className="form-control"
            name="OccupantsGender"
            id="OccupantsGender"
            value={formData?.OccupantsGender ?? '.'}
            onChange={(e) => onChange('OccupantsGender', e.target.value)}>
            <option value="."> </option>
            <option value="female">Female</option>
            <option value="male">Male</option>
            <option value="female-id-as-male">Identify as Male</option>
            <option value="male-id-as-female">Identify as Female</option>
            <option value="non-binary">Non Binary</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="ChaperonesName">
          Chaperone's Name
        </label>
        <div className="col-sm-6">
          <input
            className="form-control"
            type="text"
            name="ChaperonesName"
            id="ChaperonesName"
            value={formData?.ChaperonesName ?? ''}
            onChange={(e) => onChange('ChaperonesName', e.target.value)}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="RoommatesName">
          Roommate's Name
        </label>
        <div className="col-sm-6">
          <input
            className="form-control"
            type="text"
            name="RoommatesName"
            id="RoommatesName"
            value={formData?.RoommatesName ?? ''}
            onChange={(e) => onChange('RoommatesName', e.target.value)}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-6" htmlFor="Needs">
          ADA Needs & Notes
        </label>
        <div className="col-sm-6">
          <textarea className="form-control" name="Needs" id="Needs" value={formData?.Needs ?? ''} onChange={(e) => onChange('Needs', e.target.value)}></textarea>
        </div>
      </div>
    </>
  );
};

export default HousingPackageFormFields;
